"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.json.parse.js");
require("core-js/modules/es.object.keys.js");
var _filePreviewer = _interopRequireDefault(require("./filePreviewer.vue"));
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    FilePreviewer: _filePreviewer.default
  },
  data: function data() {
    return {
      parsedFiles: [],
      appName: ''
    };
  },
  created: function created() {
    this.parsedFiles = JSON.parse(this.$route.query.files || '[]');
    this.appName = this.$route.query.appName || '';
  }
};